// Native details and ordinary links work before this progressive enhancement.
const navigationDisclosures = [...document.querySelectorAll('[data-nav-disclosure]')];
function closeNavigation(disclosure, restoreFocus = false) {
  disclosure.open = false;
  if (restoreFocus) disclosure.querySelector('summary')?.focus();
}
for (const disclosure of navigationDisclosures) {
  const summary = disclosure.querySelector('summary');
  summary?.setAttribute('aria-expanded', String(disclosure.open));
  disclosure.addEventListener('toggle', () => {
    summary?.setAttribute('aria-expanded', String(disclosure.open));
    if (disclosure.classList.contains('mobile-navigation')) summary?.setAttribute('aria-label', disclosure.open ? 'Close navigation' : 'Open navigation');
  });
  disclosure.addEventListener('focusout', () => {
    setTimeout(() => { if (!disclosure.contains(document.activeElement) && !disclosure.classList.contains('mobile-navigation')) closeNavigation(disclosure); }, 0);
  });
}
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  for (const disclosure of navigationDisclosures) if (disclosure.open) closeNavigation(disclosure, true);
});
document.addEventListener('click', event => {
  for (const disclosure of navigationDisclosures) if (disclosure.open && !disclosure.contains(event.target)) closeNavigation(disclosure);
});
const compactNavigation = matchMedia('(max-width: 960px)');
compactNavigation.addEventListener('change', () => navigationDisclosures.forEach(disclosure => closeNavigation(disclosure)));
